import { render, staticRenderFns } from "./Equipe.vue?vue&type=template&id=68bba308"
import script from "./Equipe.vue?vue&type=script&lang=js"
export * from "./Equipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports